export const sitCount = [
  {
    id: 1,
    title: 'A1',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 2,
    title: 'A2',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 3,
    title: 'A3',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 4,
    title: 'A4',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 5,
    title: 'A5',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 6,
    title: 'A6',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 7,
    title: 'A7',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 8,
    title: 'A8',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 9,
    title: 'A9',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 10,
    title: 'A10',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 11,
    title: 'A11',
    isAvailable: true,
    isSelected: false,
  },
  {
    id: 12,
    title: 'A12',
    isAvailable: true,
    isSelected: false,
  },
];
